const asyncRoute = [
	{
	    path: "/administratorList",
	    component: () => import('../page/userManager/administratorList.vue'),
	    meta: {
	        title: "管理人列表"
	    }
	},{
        path: "/creditorList",
        component: () => import('../page/userManager/creditorList.vue'),
        meta: {
            title: "用户列表"
        }
    },
   
   //  {
   //      path: "/agentList",
   //      component: () => import('../page/userManager/agentList.vue'),
   //      meta: {
   //          title: "代理人列表"
   //      }
   //  }
	// ,{
 //        path: "/streamerList",
 //        component: () => import('../page/streamer/streamerList.vue'),
 //        meta: {
 //            title: "直播人列表"
 //        }
 //    }
]
export default asyncRoute